import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import classNames from 'classnames'

import { setHardSelectedEvent } from '@/reducers/media/media.actions'
import { formatDuration } from '@/utils/helpers'

import { DeckItemEventBlock } from './DeckItemEventBlock'
import {
  HARD_SELECTED_EVENT_ID,
  removeCallExplorerParams,
  SECTION_NAMES,
  updateCallExplorerParams,
} from './helpers'

const DECK_SECTION = 'deck'

export const EventBlock = ({ event, highlighted }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  const {
    mediaPlayer: { hardSelectedEvent },
  } = useSelector((state) => state.media)
  const { id, timestamp, section, category, item, subEvents, question, answer } = event

  // Determine if this is a deck item
  // and we need to display deck list item events
  const isDeckSection = section === DECK_SECTION
  const hasSubEvents = isDeckSection && subEvents?.length > 0

  const isHardSelectedEvent = hardSelectedEvent?.id === id && id
  const isSoftSelectedEvent = highlighted

  const updateURL = (eventId, timestamp) => {
    updateCallExplorerParams(location, history, { eventId, timestamp })
  }

  const removeEventFromURL = () => {
    removeCallExplorerParams(location, history, ['eventId'])
  }

  const onMainEventClick = () => {
    if (isHardSelectedEvent) {
      removeEventFromURL()
    } else {
      updateURL(id, timestamp)
    }
    dispatch(setHardSelectedEvent({ id, timestamp, displayText: item, section }))
  }

  const onSubEventClick = (subEventId, subEventTimestamp, subEventItem) => {
    if (hardSelectedEvent?.id === subEventId) {
      removeEventFromURL()
    } else {
      updateURL(subEventId, subEventTimestamp)
    }
    dispatch(
      setHardSelectedEvent({
        id: subEventId,
        timestamp: subEventTimestamp,
        displayText: subEventItem,
        section,
      })
    )
  }

  return (
    <div className="events-block">
      <div
        id={isHardSelectedEvent ? HARD_SELECTED_EVENT_ID : ''}
        className={classNames('events-main-container', {
          'soft-selected': isSoftSelectedEvent,
          'hard-selected': isHardSelectedEvent,
        })}
        onClick={onMainEventClick}
        data-testid="main-event-container"
      >
        <div className="event-start-time">{formatDuration(timestamp)}</div>
        <div className="event-detail-container">
          <div className="event-section-category">
            <span
              className={classNames(
                'section-category-label',
                `event-section-${section || 'QACopilot'}`
              )}
              data-testid={`event-section-${section || 'QACopilot'}`}
            >
              {SECTION_NAMES[section] || 'Quality'}
            </span>{' '}
            {Boolean(category || event.scorecard_name) && (
              <span className="section-category-label event-category">
                {category || event.scorecard_name}
              </span>
            )}
          </div>
          <span className="event-item">{item || event.criteria_name}</span>
          {Boolean(question) && <span className="event-item">{question}</span>}
          {Boolean(answer) && <span className="event-item">{answer}</span>}
        </div>
      </div>
      {hasSubEvents && (
        <div className="deck-list-items-container" data-testid="deck-list-items-container">
          {subEvents.map((subevent) => {
            const {
              id: subEventId,
              timestamp: subEventTimestamp,
              item: subEventItem,
              isNoResponse,
            } = subevent
            const isHardSelectedSubEvent = hardSelectedEvent?.id === subEventId

            return (
              <DeckItemEventBlock
                key={subEventId}
                dataTestId={`decklist-event-${subEventId}`}
                timestamp={subEventTimestamp}
                item={subEventItem}
                showTimestamp={!isNoResponse}
                onClick={() => onSubEventClick(subEventId, subEventTimestamp, subEventItem)}
                isHardSelectedEvent={isHardSelectedSubEvent}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
